"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Env {
    constructor(width, height, numberOfStates, maxNumberOfActions) {
        this.width = width;
        this.height = height;
        this.numberOfStates = numberOfStates;
        this.numberOfActions = maxNumberOfActions;
    }
    get(fieldname) {
        return this[fieldname] ? this[fieldname] : undefined;
    }
}
exports.Env = Env;
//# sourceMappingURL=env.js.map